/**
 * Canonical multi-key pause flags so pause locks work across businessId forms
 * (uuid vs business_uuid) and partial keys from older builds.
 */

import { kvGet, kvSet, kvRemove, kvKeysStartingWith } from '../infrastructure/storage/kvAccess';
import { normalizeBusinessStorageId } from './sharedCore';

export function cashRegisterPauseKeys(businessId) {
  if (!businessId) return [];
  const raw = String(businessId);
  const normalized = normalizeBusinessStorageId(businessId);
  const keys = [];
  const add = (k) => {
    if (k && !keys.includes(k)) keys.push(k);
  };
  add(`cash_register_paused_${normalized}`);
  add(`cash_register_paused_${raw}`);
  if (!raw.startsWith('business_')) add(`cash_register_paused_business_${raw}`);
  if (normalized && normalized !== raw) {
    add(`cash_register_paused_business_${normalized}`);
    add(`cash_register_paused_${normalized}`);
  }
  return keys;
}

/** Write pause on every known key form for this business (lock is reliable). */
export function setCashRegisterPaused(workerId, businessId) {
  if (workerId == null || !businessId) return false;
  const bid = normalizeBusinessStorageId(businessId) || String(businessId);
  const data = {
    workerId,
    pausedAt: new Date().toISOString(),
    businessId: bid
  };
  try {
    cashRegisterPauseKeys(businessId).forEach((key) => kvSet(key, data));
    return true;
  } catch (error) {
    console.error('[cashRegisterPause] set failed:', error);
    return false;
  }
}

/** Read pause flag if any key form is set. */
export function getCashRegisterPaused(businessId) {
  if (!businessId) return null;
  try {
    for (const key of cashRegisterPauseKeys(businessId)) {
      const value = kvGet(key);
      if (value && value.workerId != null) return value;
    }
    return null;
  } catch (error) {
    console.error('[cashRegisterPause] get failed:', error);
    return null;
  }
}

/** Clear all pause key forms for a business, or every pause flag if no id. */
export function clearCashRegisterPaused(businessId = null) {
  try {
    if (businessId) {
      cashRegisterPauseKeys(businessId).forEach((key) => kvRemove(key));
      return true;
    }
    kvKeysStartingWith('cash_register_paused_').forEach((key) => kvRemove(key));
    return true;
  } catch (error) {
    console.error('[cashRegisterPause] clear failed:', error);
    return false;
  }
}

/** True when a different cashier tries to enter while pause is active. */
export function isPausedForOtherWorker(businessId, workerId) {
  const pause = getCashRegisterPaused(businessId);
  if (!pause || pause.workerId == null) return false;
  return String(pause.workerId) !== String(workerId);
}
